import React, { useState } from 'react';
import loadable from '@loadable/component';
import { getQueryParam } from '@pegasus/utils';
const SuccessOverlaySelector = loadable(() => import(/* webpackChunkName: "browsing-overlays" */ './success-overlay-selector'), {
    resolveComponent: components => components.SuccessOverlaySelector,
});
export const LazySuccessOverlaySelector = ({ email, onClose, queryString, }) => {
    const [overlayType] = useState(() => getQueryParam('success-overlay', queryString));
    if (overlayType) {
        return React.createElement(SuccessOverlaySelector, { email: email, onClose: onClose, type: overlayType });
    }
    return null;
};
//# sourceMappingURL=lazy-success-overlay-selector.js.map